import axios from "axios";

export const fetchL1SupportDocuments = async () => {
  const token = JSON.parse(localStorage.getItem("token"));
  const url = `${process.env.REACT_APP_API_URL}/l1-support-documents`;
  const response = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
